import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';

import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { MainService } from '../../service/main.service'

@Component({
  selector: 'gw-nav',
  templateUrl: './header.component.html',
  styleUrls: ['../comment.component.styl']
})
export class HeaderComponent {
  activeUrl:string = "1";
  logo_title: string;
  constructor(public router: Router, public activatedRoute: ActivatedRoute, public mainService: MainService) { 	
  }
  ngOnInit() {
  	this.router.events
      .filter(event => event instanceof NavigationEnd)
      .map(() => this.activatedRoute)
      .map(route => {
        while (route.firstChild) route = route.firstChild;
        return route;
      })
      .filter(route => route.outlet === 'primary')
      .mergeMap(route => route.data)
      .subscribe((event) => this.activeUrl=event['activeUrl']);
    this.mainService.getCommentData()
      .subscribe(
        data =>{
          this.logo_title = data.logo_title;
        },
        error => {        
        }
    )
  }
}



// WEBPACK FOOTER //
// C:/Users/Administrator/submit text project/gwin/src/app/comment/header/header.component.ts